module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/init/init.component.css
// module id = ./src/app/init/init.component.css
// module chunks = main